import { defaultOptionState } from './module-options-state';

export default {
	resetState(state) {
		Object.assign(state, defaultOptionState);
	},
	updateOptionsData(state, data) {
		state.OptionsData.removeAll();
		state.OptionsData.append(data);
	}
};
